import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowUpRight, Phone } from 'lucide-react';
import './Navbar.css';

const NAV = [
  { to:'/', label:'Home' },
  { to:'/about', label:'About' },
  { to:'/products', label:'Products' },
  { to:'/global-reach', label:'Our Reach' },
  { to:'/contact', label:'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', fn); fn();
    return () => window.removeEventListener('scroll', fn);
  }, []);
  useEffect(() => { setOpen(false); }, [pathname]);
  const solid = scrolled || pathname !== '/';
  return (
    <>
      <div className="topbar">
        <div className="container topbar__inner">
          <span>🇮🇳 Pune, Maharashtra · GSTIN: 27CBFPB6539R1Z2</span>
          <div className="topbar__right">
            <a href="tel:+917775892822"><Phone size={11}/> +91 77758 92822</a>
            <span>·</span>
            <a href="mailto:yashrajtradersindia11@gmail.com">yashrajtradersindia11@gmail.com</a>
          </div>
        </div>
      </div>
      <header className={`nav ${solid ? 'nav--solid' : ''}`}>
        <div className="nav__bar container">
          <Link to="/" className="nav__logo">
            <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Yashraj Traders India" className="nav__logo-img"/>
            <div className="nav__logo-text">
              <span className="nav__logo-name">Yashraj Traders</span>
              <span className="nav__logo-sub">India · Import · Export</span>
            </div>
          </Link>
          <nav className="nav__links">
            {NAV.map(n => (
              <Link key={n.to} to={n.to} className={`nav__link ${pathname===n.to?'nav__link--on':''}`}>{n.label}</Link>
            ))}
          </nav>
          <div className="nav__right">
            <Link to="/contact" className="btn btn-fire nav__cta">Enquire Now <ArrowUpRight size={14}/></Link>
            <button className="nav__ham" onClick={() => setOpen(!open)}>{open ? <X size={22}/> : <Menu size={22}/>}</button>
          </div>
        </div>
        <div className={`nav__mobile ${open ? 'nav__mobile--open' : ''}`}>
          <div className="nav__mobile-inner">
            {NAV.map(n => (
              <Link key={n.to} to={n.to} className={`nav__mob-link ${pathname===n.to?'nav__mob-link--on':''}`}>
                <span>{n.label}</span>{pathname===n.to && <div className="nav__mob-dot"/>}
              </Link>
            ))}
            <Link to="/contact" className="btn btn-fire" style={{marginTop:12,justifyContent:'center'}}>Enquire Now <ArrowUpRight size={14}/></Link>
          </div>
        </div>
      </header>
    </>
  );
}
